export default __webpack_public_path__ + "static/media/Signbg.3b65f1a5.jpg";